// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__zCRII","divider":"styles_divider__ksMlp"};